import { useEffect, useMemo, useReducer } from 'react';
import { Link, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import moment from 'moment';
import _ from 'lodash';

import { bindActionCreators } from 'redux';
import * as Actions from 'redux/actions';

import RectangularButton from 'components/elements/molecules/RectangularButton/RectangularButton';
import { ICONS, Icon } from 'components/Icons';
import SourceLogo from '../../ActivityTab/TopicsTab/SourceLogo';
import QuizQuestions from './QuizQuestions';
import { handleEvent } from 'helpers';

import './ChannelPageQuiz.scss';
import { QuestionFeeback } from 'routes/Chrome/ArticleQuiz/ArticleQuiz';
import ActionLink from 'components/elements/molecules/ActionLink/ActionLink';
import { Modal } from 'react-bootstrap';

function ChannelPageQuiz({
  articleId,
  returnToChannelPage,
  mediaChannel = {},
  actions,
}) {
  const allArticleQuiz = typeof articleId !== 'string';

  const [state, dispatch] = useReducer(
    (state, action) => {
      switch (action.type) {
        case 'SET_ARTICLES':
          return {
            ...state,
            articles: action.payload.articles,
          };
        case 'SHOW_NEXT_QUIZ':
          return {
            ...state,
            articleIndex: state.articleIndex + 1,
          };
        case 'SET_SHOW_WELCOME_MESSAGE':
          return {
            ...state,
            welcomeMessage: action.payload,
          };
        case 'SET_SUBMITTING_STATE':
          return {
            ...state,
            isSubmitting: action.payload,
          };
        case 'SET_SHOW_QUESTION_FEEDBACK':
          return {
            ...state,
            showQuestionFeedback: action.payload.showQuestionFeedback,
            feedbackQuestionIndex: action.payload.feedbackQuestionIndex,
          };
        case 'SET_ANSWER_QUESTION':
          const articles = _.cloneDeep(state.articles);

          const question = action.payload.question;
          const questionIndex = action.payload.index;
          const currentArticleId = action.payload.currentArticleId;

          const article = articles.find((a) => a.pointId === currentArticleId);
          const quizQuestions = article.quizQuestions;

          quizQuestions.splice(questionIndex, 1, question);

          return {
            ...state,
            articles,
          };
        default:
          return state;
      }
    },
    {
      articles: [],
      articleIndex: 0,
      welcomeMessage: allArticleQuiz,
      isSubmitting: false,
      showQuestionFeedback: false,
      feedbackQuestionIndex: -1,
    },
  );

  useEffect(() => {
    const topStories = _.cloneDeep(mediaChannel.topStories || []);

    const articlesWithQuiz = topStories.filter((topStory) => {
      const questionsExist =
        Array.isArray(topStory.quizQuestions) &&
        topStory.quizQuestions.length > 0;

      return questionsExist;
    });

    if (!articlesWithQuiz.length) {
      return returnToChannelPage();
    }

    const index = articlesWithQuiz.findIndex(
      (article) => article.pointId === articleId,
    );

    if (index > 0) {
      const selectedArticle = articlesWithQuiz[index];

      articlesWithQuiz.splice(index, 1);

      articlesWithQuiz.unshift(selectedArticle);
    }

    dispatch({
      type: 'SET_ARTICLES',
      payload: { articles: articlesWithQuiz },
    });
  }, [mediaChannel.topStories]);

  function showReturnToChannelPageLink() {
    return (
      <div
        className="quiz-return-to-channel-page-link av-blue cursor-pointer"
        onClick={() => returnToChannelPage()}
      >
        Return To Channel Page
      </div>
    );
  }

  function showHeader() {
    return <div className="quiz-header">Weekly News Quiz</div>;
  }

  function showNumberOfArticles() {
    if (state.welcomeMessage) {
      return (
        <div className="quiz-number-of-articles">
          {state.articles.length} article{state.articles.length > 1 ? 's' : ''}
        </div>
      );
    }

    return (
      <div className="quiz-number-of-articles">
        {state.articleIndex + 1} of {state.articles.length} article
        {state.articles.length > 1 ? 's' : ''}
      </div>
    );
  }

  function showWelcomeMessage() {
    return (
      <div className="quiz-welcome-message">
        <div className="mt-4 av-blue font-weight-600 welcome-header">
          Welcome to the Weekly News Quiz
        </div>
        <div className="mt-4">
          The AverPoint weekly news quiz asks you questions about the top
          articles from the week.
        </div>
        <div className="mt-3 d-flex justify-content-end">
          <RectangularButton
            darkButton
            onClick={() => {
              dispatch({
                type: 'SET_SHOW_WELCOME_MESSAGE',
                payload: false,
              });
            }}
          >
            <div className="d-flex align-items-center">
              Next
              <Icon className="ml-2" icon={ICONS.RIGHT} />
            </div>
          </RectangularButton>
        </div>
      </div>
    );
  }

  const currentArticle = state.articles[state.articleIndex];

  console.log('article =>', currentArticle);

  function renderSubmitQuizBtn(quizQuestions) {
    if (
      !quizQuestions ||
      !quizQuestions.filter((i) => !i.userAnswer || !i.userAnswer.isSubmitted)
        .length
    ) {
      if (allArticleQuiz) {
        return (
          <RectangularButton
            onClick={async () => {
              dispatch({
                type: 'SHOW_NEXT_QUIZ',
              });
            }}
            darkButton
          >
            Next
          </RectangularButton>
        );
      }

      return null;
    }

    if (state.isSubmitting) {
      return (
        <div className="text-center">
          <div
            className="fa fa-spin fa-spinner text-primary"
            style={{ fontSize: '20px' }}
          />
        </div>
      );
    }

    return (
      <RectangularButton
        onClick={async () => {
          try {
            dispatch({
              type: 'SET_SUBMITTING_STATE',
              payload: true,
            });

            await Promise.all(
              currentArticle.quizQuestions.map((question) => {
                handleEvent('QUIZ_QUESTION_ANSWERED', {
                  questionId: question._id,
                  answers: question.userAnswer.answersIndex,
                  questionText: question.text,
                  articleMediaCollectionId: currentArticle.pointId,
                });

                return actions.checkQuizAnswer(
                  question._id,
                  question.userAnswer.answersIndex,
                );
              }),
            );

            await actions.submitQuiz(currentArticle.pointId);

            handleEvent('QUIZ_SUBMITTED', {
              articleMediaCollectionId: currentArticle.pointId,
              topicId: null,
            });

            await actions.getQuizQuestionsForArticle(
              currentArticle.pointId,
              null,
              null,
              true,
              true,
            );
          } catch (error) {
            console.error('Error while submitting quiz', error);
          } finally {
            dispatch({
              type: 'SET_SUBMITTING_STATE',
              payload: false,
            });
          }
        }}
        darkButton
        disabled={currentArticle.quizQuestions.some(
          (question) =>
            !question.userAnswer ||
            !Array.isArray(question.userAnswer.answersIndex) ||
            question.userAnswer.answersIndex.length === 0,
        )}
      >
        Submit Quiz
      </RectangularButton>
    );
  }

  function showArticleDetails() {
    if (!currentArticle || state.welcomeMessage) {
      return null;
    }

    return (
      <div className="article-quiz-fix-section">
        {/* <div className="article-quiz-title">Article {state.articleIndex + 1}</div> */}
        <div className="d-flex align-items-center mt-4 source-logo">
          <SourceLogo url={currentArticle.sourceURL} displaySourceName />
        </div>
        <div className="mt-3">
          <a
            className="av-blue"
            target="_blank"
            href={currentArticle.sourceURL}
          >
            {currentArticle.sourceTitle}
          </a>
        </div>
        <div className="mt-1 av-gray source-date">
          {moment(currentArticle.sourceDate).format('MM/DD/YYYY')}
        </div>
      </div>
    );
  }

  function renderQuestionFeedback() {
    if (!state.showQuestionFeedback || !currentArticle.quizQuestions) {
      return null;
    }

    const question = currentArticle.quizQuestions[state.feedbackQuestionIndex];

    if (!question) {
      return null;
    }

    const onClose = () => {
      dispatch({
        type: 'SET_SHOW_QUESTION_FEEDBACK',
        payload: {
          showQuestionFeedback: false,
        },
      });
    };

    return (
      <Modal show className="confirmation-end-writing-prompt">
        <Modal.Header closeButton onHide={() => onClose()}>
          <Modal.Title>Feedback</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <QuestionFeeback
            question={question}
            onClose={() => onClose()}
            actions={actions}
            articleMediaCollectionId={currentArticle.pointId}
            isChannelPageQuiz
          />
        </Modal.Body>
      </Modal>
    );
  }

  function renderQuestionFeedbackBtn(question, index) {
    console.log('question 2', question);
    if (!question.userAnswer || !question.userAnswer.isSubmitted) {
      return null;
    }

    return (
      <div className="d-flex mt-2">
        <ActionLink
          onClick={async () => {
            dispatch({
              type: 'SET_SHOW_QUESTION_FEEDBACK',
              payload: {
                showQuestionFeedback: true,
                feedbackQuestionIndex: index,
              },
            });
          }}
          linkClassName="av-blue ml-auto"
          label="Feedback"
        />
      </div>
    );
  }

  function showArticleQuiz() {
    if (!currentArticle) {
      return null;
    }

    return (
      <div className="article-quiz-container">
        <div className="mt-4 questions-count">
          {currentArticle.quizQuestions.length} Questions
        </div>
        <div className="mt-4">
          {currentArticle.quizQuestions.map((quizQuestion, index) => (
            <div className="quiz-question">
              <QuizQuestions
                key={quizQuestion.pointId}
                question={quizQuestion}
                readOnly={
                  quizQuestion.userAnswer && quizQuestion.userAnswer.isSubmitted
                }
                updateQuestion={(question) => {
                  console.log('question', question);
                  dispatch({
                    type: 'SET_ANSWER_QUESTION',
                    payload: {
                      currentArticleId: currentArticle.pointId,
                      index,
                      question,
                    },
                  });
                }}
                onFeedback={() => {
                  dispatch({
                    type: 'SET_SHOW_QUESTION_FEEDBACK',
                    payload: {
                      showQuestionFeedback: true,
                      feedbackQuestionIndex: index,
                    },
                  });
                }}
                isChannelPageQuiz
              />
              {/* {renderQuestionFeedbackBtn(quizQuestion, index)} */}
            </div>
          ))}
        </div>
        <div className="mt-4 d-flex justify-content-end">
          {renderSubmitQuizBtn(currentArticle.quizQuestions)}
        </div>
      </div>
    );
  }

  return (
    <div className="container channel-page-quiz">
      <div className="channel-page-fix-section">
        {showReturnToChannelPageLink()}
        {showHeader()}
        {allArticleQuiz && showNumberOfArticles()}
        {showArticleDetails()}
      </div>
      {state.welcomeMessage ? showWelcomeMessage() : showArticleQuiz()}
      {renderQuestionFeedback()}
    </div>
  );
}

function mapStateToProps(state, ownProps) {
  return {
    mediaChannel: state.mediaLogs.mediaChannel,
    user: state.user.user,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(Actions, dispatch),
  };
}

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ChannelPageQuiz),
);
